export default __webpack_public_path__ + "static/media/843.451bcce5.gif";